import {
    TrueBase,
    html,
    css
} from "../TrueBase/TrueBase";
import "../TrueGrid/TrueGrid";

export class TrueDualContent extends TrueBase {
    static get properties() {
        return {
            flipOnMobile: {
                type: Boolean
            }
        }
    }

    constructor() {
        super();
    }

    render() {
        return html `
             <true-grid>
                <slot name="left"></slot>
                <slot name="right"></slot>
             </true-grid>
        `
    }

    static get styles() {
        return [super.styles, css`
            :host {
                display: block;
                border-radius: var(--dual-content-border-radius, 0px);
                border: var(--dual-content-border, none);
                overflow: hidden;
                --grid-margin-top: 0;
            }

            true-grid {
                height: 100%;
            }

            ::slotted([slot="left"]),
            ::slotted([slot="right"]) {
                position: relative;
                box-sizing: border-box;
            }

            ::slotted(*) {
                min-height: var(--dual-content-image-height, 400px);
            }

            @media screen and (max-width: 768px) {
                ::slotted(*) {
                    min-height: calc(var(--dual-content-image-height, 400px) / 2);
                }
            }

            @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {  
            /* IE10+ specific styles go here */  
                true-image-responsive, true-image, div {
                    min-height: var(--dual-content-image-height, 400px);
                    height: 100%;
                }

                true-grid ::slotted(*) {
                    max-width: 50%;
                    margin: 0;
                }
            }

            @media screen and (max-width: 768px) {
                :host([flipOnMobile]) true-grid {
                    display: flex;
                    flex-direction: column-reverse;
                }
            }
        `];
    }
}

window.customElements.get("true-dual-content") || window.customElements.define('true-dual-content', TrueDualContent);